import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { ImageTransformation } from "@cloudinary/transformation-builder-sdk/transformation/ImageTransformation";
import { CloudinaryTransformable } from "./CloudinaryTransformable.js";
/**
 * @desc Cloudinary image asset, with image-related transformations
 * @summary SDK
 * @memberOf SDK
 */
var CloudinaryImage = /*#__PURE__*/function (_CloudinaryTransforma) {
  function CloudinaryImage(publicID, cloudConfig, urlConfig) {
    _classCallCheck(this, CloudinaryImage);
    /* istanbul ignore next */
    return _callSuper(this, CloudinaryImage, [publicID, cloudConfig, urlConfig, new ImageTransformation()]);
  }
  _inherits(CloudinaryImage, _CloudinaryTransforma);
  return _createClass(CloudinaryImage);
}(CloudinaryTransformable);
export { CloudinaryImage };